<template>
    <section>
        <h3 class="text-center">Welcome to RiteTag</h3>

        <p v-if="state === 'code'" class="text-center">Enter your code</p>
        <p v-else class="text-center">Enter your email address</p>
        <div class="form-inline center">
            <input v-if="state === 'login' || state === 'signup'" v-model="email" type="email" placeholder="email" class="form-control">
            <input v-if="state === 'code'" v-model="code" type="text" placeholder="code" class="form-control">
            <button v-if="state === 'login'" @click="getCode(false)" class="btn btn-primary sgn-padd"><font-awesome-icon v-if="loading" :icon="['fas', 'spinner']" spin/> Continue</button>
            <button v-if="state === 'code'" @click="login" class="btn btn-primary sgn-padd"><font-awesome-icon v-if="loading" :icon="['fas', 'spinner']" spin/> Login</button>
            <button v-if="state === 'signup'" @click="getCode(true)" class="btn btn-primary sgn-padd"><font-awesome-icon v-if="loading" :icon="['fas', 'spinner']" spin/> Create account</button>
            <button v-if="state === 'code' || state === 'signup'" @click="back" class="btn btn-secondary sgn-padd">Back</button>
        </div>
        <p class="text-center"></p>
        <hr><p class="text-center">... or sign in with your social media account</p>
        <div :class="{'login-buttons': true, 'fade-in': fadeIn, 'grid-btn': true}">
            <div>
                <a class="signup twitter-bg-color" href="https://ritekit.com/sign/vue?site=twitter">
                    <font-awesome-icon :icon="['fab', 'twitter']" size="lg" fixed-width /> Continue with Twitter
                </a>
            </div>
            <div>
                <a class="signup facebook-bg-color" href="https://ritekit.com/sign/vue?site=facebook">
                    <font-awesome-icon :icon="['fab', 'facebook-f']" size="lg" fixed-width /> Continue with Facebook
                </a>
            </div>
            <div>
                <a class="signup default-color" href="https://ritekit.com/sign/vue?site=buffer">
                    <font-awesome-icon :icon="['fab', 'buffer']" size="lg" fixed-width /> Continue with Buffer
                </a>
            </div>
        </div>
    </section>
</template>

<script>
    import {api} from '../_services'

    export default {
        name: 'Login',
        data: () => {
            return {
                fadeIn: true,
                loading: false,
                state: 'login',
                email: '',
                code: ''
            }
        },
        methods: {
            fade () {
                this.fadeIn = false
                setTimeout(() => {
                    this.fadeIn = true
                }, 100)

            },
            getCode(create) {
                if (!this.validateEmail(this.email)) {
                    this.$notify({ type: 'error', text: 'Enter valid email.' })
                } else {
                    this.loading = true
                    api.getCode(this.email, create)
                        .then(res => {
                            this.$notify({ type: 'success', text: res.data.message})
                            this.state = 'code'
                            this.loading = false
                        })
                        .catch(err => {
                            this.$notify({ type: 'error', text: err.response.data.message })
                            this.state = 'signup'
                            this.loading = false
                        })
                }
            },
            back() {
                this.state = 'login'
            },
            login() {
                if (/^\d+$/gm.test(this.code)) {
                    this.laoding = true
                    window.location.replace("https://ritekit.com/sign/code?email=" + encodeURIComponent(this.email) + '&code='+encodeURIComponent(this.code));
                } else {
                    this.$notify({ type: 'error', text: 'Invalid code.' })
                }
            },
            validateEmail(email) {
                var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
                return re.test(String(email).toLowerCase());
            }
        },
        mounted() {
            this.$root.$on('login-fade-in', () => {
                this.fade()
            })
        }
    }
</script>

<style scoped lang="scss">
    .grid-btn {
        display: grid;
        grid-template-columns: 1fr 1fr 1fr;
    }
    h3 {
        margin-top: 30px;
    }
    .sgn-padd {
        margin: 12px 3px;
    }
    .login-buttons {
        margin-left: auto;
        margin-right: auto;
        margin-top: 30px;
    }
    .center {
        max-width: 370px;
        margin-left: auto;
        margin-right: auto;
    }
    .signup {
        width: 250px;
        display: inline-block;
        padding: 10px 10px;
        margin-left: 5px;
        font-size: 12pt;
        text-align: center;
        color: #fff;
        border-radius: 5px;
    }

    .default-color {
        background-color: #fff;
        color: #000;
        border: 1px solid #c7c7c7;
        &:hover {
            background-color: $gray-100 !important;
            text-decoration: none;
        }
    }

    .twitter-bg-color {
        background-color: $twitterColor !important;
        &:hover {
            background-color: lighten( $twitterColor, 10%) !important;
            text-decoration: none;
        }
    }

    .facebook-bg-color {
        background-color: $facebookColor !important;
        &:hover {
            background-color: lighten( $facebookColor, 10%) !important;
            text-decoration: none;
        }
    }

    .fade-in {
        -webkit-animation: fade-in 1.2s cubic-bezier(0.390, 0.575, 0.565, 1.000) both;
        animation: fade-in 1.2s cubic-bezier(0.390, 0.575, 0.565, 1.000) both;
    }
    /* ----------------------------------------------
     * Generated by Animista on 2019-8-23 13:53:19
     * w: http://animista.net, t: @cssanimista
     * ---------------------------------------------- */

    /**
     * ----------------------------------------
     * animation fade-in
     * ----------------------------------------
     */
    @-webkit-keyframes fade-in {
        0% {
            opacity: 0;
        }
        100% {
            opacity: 1;
        }
    }
    @keyframes fade-in {
        0% {
            opacity: 0;
        }
        100% {
            opacity: 1;
        }
    }


</style>
